import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { UIRouter } from '@uirouter/angular';

@Injectable()
export class CookiesConsentService {
  private acceptedCookieKey: string = 'jb.acceptedCookies';

  private _isVisible: boolean = null;

  private _isVisibleSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(this._isVisible);

  get visibility(): Observable<boolean> {
    return this._isVisibleSubject.asObservable();
  }

  get isVisible(): boolean {
    return this._isVisible;
  }

  constructor(
    private cookieService: CookieService,
    private routerService: UIRouter
  ) {
  }

  public determineVisibility() {
    this._isVisible = !this.cookieService.get(this.acceptedCookieKey);

    this._isVisibleSubject.next(this._isVisible);
  }

  public accept() {
    this.cookieService.put(this.acceptedCookieKey, '1', {
      expires: new Date(new Date().setFullYear(new Date().getFullYear() + 3))
    });

    this._isVisible = false;

    this._isVisibleSubject.next(this._isVisible);
  }

  public close() {
    this._isVisible = false;

    this._isVisibleSubject.next(this._isVisible);
  }
}



// WEBPACK FOOTER //
// ./src/app/cookies/consent/consent.service.ts